import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-680fbb46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"position":"relative","width":"100%"} }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "no-project-title" }, " GAME OVER ", -1))
const _hoisted_4 = { class: "no-project-subtitle" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "mario-walking-container" }
const _hoisted_9 = { class: "mario-walking-content" }
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mario-walking-ground" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GlitchText = _resolveComponent("GlitchText")!
  const _component_ProjectFiltering = _resolveComponent("ProjectFiltering")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_ProjectPreview = _resolveComponent("ProjectPreview")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_ProjectPreviewGrid = _resolveComponent("ProjectPreviewGrid")!

  return (_openBlock(), _createElementBlock("div", {
    id: "projects",
    class: _normalizeClass(["all-projects-container bg-grid-effect", {
            'all-projects-container-line-view': _ctx.viewMode === _ctx.EViewMode.line,
            'all-projects-container-grid-view': _ctx.viewMode === _ctx.EViewMode.grid
        }])
  }, [
    _createVNode(_component_GlitchText, {
      class: "mb-6",
      text: _ctx.$vuetify.locale.t('$vuetify.projects.title')
    }, null, 8, ["text"]),
    _createVNode(_component_ProjectFiltering, {
      viewMode: _ctx.viewMode,
      disable: _ctx.soLongAnimation || _ctx.showMarioHammerAnimation,
      onViewModeChange: _cache[0] || (_cache[0] = newViewMode => _ctx.viewMode = newViewMode),
      onTypeChange: _cache[1] || (_cache[1] = newTypes => _ctx.projectTypes = newTypes),
      onSearchChange: _cache[2] || (_cache[2] = newSearch => _ctx.searchFilter = newSearch)
    }, null, 8, ["viewMode", "disable"]),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["no-project-container d-flex align-center", {
                    'no-project-out-animation': _ctx.soLongAnimation,
                    'no-project-in-animation': !_ctx.soLongAnimation
                }])
      }, [
        _createElementVNode("img", {
          alt: "Bowser face",
          class: "mx-5 sad-mario-img",
          src: require('@/assets/images/mario/bowser.png')
        }, null, 8, _hoisted_2),
        _createElementVNode("div", null, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$vuetify.locale.t('$vuetify.projects.noProject.subtitle')), 1)
        ])
      ], 2),
      (_ctx.showMarioHammerAnimation)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            id: "marioHammerAnimation",
            alt: "Mario animation",
            class: "mario-animation-img",
            src: require('@/assets/images/mario/marioHammer.gif')
          }, null, 8, _hoisted_5))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, $options.filteredProjects.length === 0 || _ctx.soLongAnimation]
    ]),
    ($options.filteredProjects.length === 0 || _ctx.soLongAnimation)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["no-project-spacer", { 'no-project-spacer-out': _ctx.soLongAnimation }])
        }, null, 2))
      : _createCommentVNode("", true),
    (_ctx.viewMode === _ctx.EViewMode.line)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([{ 'projects-in-animation': _ctx.soLongAnimation }, "line-view-container"])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["pagination-btn pagination-left-btn", {
                    'pagination-btn-hidden': !$options.filteredProjects.length || _ctx.projectPosition === 0
                }]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.scrollToProject(_ctx.projectPosition - 1)))
          }, [
            _createVNode(_component_v_icon, {
              color: "primary",
              size: "30"
            }, {
              default: _withCtx(() => [
                _createTextVNode("mdi-arrow-left-bold")
              ]),
              _: 1
            })
          ], 2),
          _createElementVNode("div", {
            class: "line-view-projects-container",
            style: _normalizeStyle(`overflow-x: ${$options.filteredProjects.length > 0 ? 'scroll' : 'auto'}`),
            ref: "lineModeContainer",
            onMouseup: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($options.onLineProjectsMouseUp && $options.onLineProjectsMouseUp(...args))),
            onMousedown: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($options.onLineProjectsMouseDown && $options.onLineProjectsMouseDown(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredProjects, (project, i) => {
              return (_openBlock(), _createBlock(_component_ProjectPreview, {
                key: i,
                title: _ctx.$vuetify.locale.t(project.title),
                description: _ctx.$vuetify.locale.t(project.description),
                resume: _ctx.$vuetify.locale.t(project.resume),
                skills: project.skills,
                imgName: project.imgName,
                dialogComponent: project.dialogComponent,
                date: project.date,
                pinned: project.pinned,
                windowWidth: _ctx.windowWidth
              }, _createSlots({
                previousButton: _withCtx(() => []),
                _: 2
              }, [
                (project.projectLink)
                  ? {
                      name: "projectLink",
                      fn: _withCtx(() => [
                        _createElementVNode("a", {
                          href: project.projectLink,
                          target: "_blank"
                        }, _toDisplayString(_ctx.$vuetify.locale.t(project.projectLinkText!)), 9, _hoisted_6)
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["title", "description", "resume", "skills", "imgName", "dialogComponent", "date", "pinned", "windowWidth"]))
            }), 128))
          ], 36),
          _createElementVNode("div", {
            class: _normalizeClass(["pagination-btn pagination-right-btn", {
                    'pagination-btn-hidden': !$options.filteredProjects.length || _ctx.projectPosition >= $options.filteredProjects.length - 1
                }]),
            onClick: _cache[6] || (_cache[6] = ($event: any) => ($options.scrollToProject(_ctx.projectPosition + 1)))
          }, [
            _createVNode(_component_v_icon, {
              color: "primary",
              size: "30"
            }, {
              default: _withCtx(() => [
                _createTextVNode("mdi-arrow-right-bold")
              ]),
              _: 1
            })
          ], 2)
        ], 2))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["grid-view-container", { 'projects-in-animation': _ctx.soLongAnimation }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredProjects, (project, i) => {
            return (_openBlock(), _createBlock(_component_ProjectPreviewGrid, {
              key: i,
              title: _ctx.$vuetify.locale.t(project.title),
              resume: _ctx.$vuetify.locale.t(project.resume),
              imgName: project.imgName,
              dialogComponent: project.dialogComponent,
              "project-link": project.projectLink,
              date: project.date,
              pinned: project.pinned
            }, _createSlots({
              append: _withCtx(() => [
                _createVNode(_component_v_divider, { class: "project-divider" })
              ]),
              _: 2
            }, [
              (project.projectLink)
                ? {
                    name: "projectLink",
                    fn: _withCtx(() => [
                      _createElementVNode("a", {
                        href: project.projectLink,
                        target: "_blank"
                      }, _toDisplayString(_ctx.$vuetify.locale.t(project.projectLinkText!)), 9, _hoisted_7)
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["title", "resume", "imgName", "dialogComponent", "project-link", "date", "pinned"]))
          }), 128))
        ], 2)),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("img", {
          id: "marioWalkingGif",
          alt: "Mario en train de marcher",
          src: require('@/assets/images/mario/marioWalking.gif')
        }, null, 8, _hoisted_10)
      ]),
      _hoisted_11
    ])
  ], 2))
}